export const truncateString = (originalStr = 'N/A', size = 16) => {
  if (originalStr === null) return '';
  return originalStr.length > size
    ? `${originalStr.slice(0, size - 1)}\u2026`
    : originalStr;
};
